// Gemini に temperature を送ってよいモデル（リグレッションテストの実験の選択肢、src/RegressionTestTab.js）。
//
// create-react-app の ModuleScopePlugin により src/ から api/ を import できないため、api/_geminiSampling.js の
// 内容をここへ複製している（変えるときは両方を同じに。tests/apiInputGuards.test.mjs の AG20 で照合）。

// temperature（と top_p・top_k）を送ってよいモデル。food-label-assist の api/_geminiModelCapabilities.js の
// SAMPLING_PARAMS_MODELS と同じ表（tests/apiInputGuards.test.mjs の AG20 で、隣に FLA があれば照合する）。
// Google の通知（2026-10-07、Google AI Studio「Update thinking_budget and sampling parameters」）:
// Gemini 3.6 Flash からはサンプリングのパラメータが既定値に固定され、temperature 等を送っても効かない。
// これからのモデルでは、送ると HTTP 400 になる。そのため、3.6 Flash より前のモデル（ここに挙げたもの）にだけ
// temperature: 0 を送り、それ以外（3.6-flash・3.7-flash と、ここに無い新しいモデル）には送らない
// （新しいモデルを試した途端に全件 400 になるのを防ぐ。送らなくても 3.6 Flash 以降では結果が変わらない）。
// seed はこの通知の対象ではないため、どのモデルにも今までどおり送る。
// Set で引く（モデル名は superadmin が選べる値のため、普通のオブジェクトの [] で引かない）
export const SAMPLING_PARAMS_MODELS = new Set([
  'gemini-3.5-flash-lite',
  'gemini-3.1-pro-preview',
  'gemini-3.1-flash-lite-image',
  'gemini-3-flash-preview',
  'gemini-3-pro-preview',
  'gemini-2.5-flash',
  'gemini-2.5-flash-lite',
  'gemini-2.0-flash',
  'gemini-2.0-flash-lite',
]);

export function supportsSamplingParams(modelName) {
  return typeof modelName === 'string' && SAMPLING_PARAMS_MODELS.has(modelName);
}
